import { analytics } from './analytics';
import { application } from './application';
import { configuration } from './configuration';
import { folder } from './folder';
import { prompt } from './prompt';
import { release } from './release';

const createFetchWithAuth =
  (token: string) =>
  async (url: string, options?: RequestInit): Promise<Response> => {
    const headers = {
      ...options?.headers,
      Authorization: `Bearer ${token}`
    };
    return fetch(url, { ...options, headers });
  };

const BlockApi = (baseUrl: string, token: string) => {
  const apiVersion = 'v1';

  const fetchWithAuth = createFetchWithAuth(token);

  return {
    application: application(`${baseUrl}/${apiVersion}/Application`, fetchWithAuth),
    configuration: configuration(`${baseUrl}/${apiVersion}/Configuration`, fetchWithAuth),
    folder: folder(`${baseUrl}/${apiVersion}/Folder`, fetchWithAuth),
    prompt: prompt(`${baseUrl}/${apiVersion}/Prompt`, fetchWithAuth),
    release: release(`${baseUrl}/${apiVersion}/Release`, fetchWithAuth),
    analytics: analytics(`${baseUrl}/${apiVersion}/Logs`, fetchWithAuth)
  };
};

export default BlockApi;
